import { Paper } from "@material-ui/core"
import { Title } from "App/Component/ui"
import { isNull, defaultToastError } from "App/utils/helpers"
import { LoadingBackdrop } from "components/atoms"
import React, { Suspense } from "react"
import { useState, useEffect } from "react"
import { getSaldoByKunjunganID, getSaldoHistoryByKunjunganID } from "./ui"
import { ModalKwitansi } from "components/molecules"

const TabMaster = React.lazy(() => import("./ui/helpers"))
const FormDetailKunjungan = React.lazy(() => import("./ui/FormDetailKunjungan"))

function Saldo() {
  const [formDetailKunjungan, setFormDetailKunjungan] = useState({
    kunjungan_id: "",
    jenis_layanan_name: "",
    tanggal_masuk: "",
    rm_id: "",
    rm_name: "",
    tagihan_id: "",
  })
  const [rowsSaldo, setRowsSaldo] = useState([])
  const [rowsHistory, setRowsHistory] = useState([])
  const [value, setValue] = useState(0)
  const [totalSaldo, setTotalSaldo] = useState(0)
  const [totalHistory, setTotalHistory] = useState(0)
  const [totalNilai, setTotalNilai] = useState(0)
  const [showModalKwitansi, setShowModalKwitansi] = useState(false)

  const setNewDataSaldo = async (id = formDetailKunjungan.kunjungan_id) => {
    if (!isNull(id)) {
      const res = await getSaldoByKunjunganID(id)
      if (res.state) {
        setRowsSaldo(res.data)
        setTotalSaldo(res.total_saldo)
      } else {
        defaultToastError(res.message)
      }

      const res2 = await getSaldoHistoryByKunjunganID(id)
      if (res2.state) {
        setRowsHistory(res2.data)
        setTotalHistory(res2.data.length > 0 ? res2.data[0].jumlah_bayar : 0)
      } else {
        defaultToastError(res2.message)
      }
    }
  }

  useEffect(() => {
    ;(async () => {
      await setNewDataSaldo()
    })()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const handleClickCetak = (nilai) => {
    setTotalNilai(nilai)
    setShowModalKwitansi(true)
  }

  return (
    <>
      {showModalKwitansi && (
        <ModalKwitansi
          nama={formDetailKunjungan.rm_name}
          noRM={formDetailKunjungan.rm_id}
          nilai={totalNilai}
          setShowModal={() => setShowModalKwitansi(false)}
          no_transaksi={""}
        />
      )}
      <Suspense fallback={<LoadingBackdrop />}>
        <Title title={"Saldo"} />
        <Paper className="p-1">
          <FormDetailKunjungan
            value={value}
            formDetailKunjungan={formDetailKunjungan}
            setFormDetailKunjungan={setFormDetailKunjungan}
            setNewDataSaldo={setNewDataSaldo}
            totalSaldo={totalSaldo}
            totalHistory={totalHistory}
            handleClickCetak={handleClickCetak}
          />

          <div className="mt-2">
            <TabMaster
              value={value}
              setValue={setValue}
              rowsSaldo={rowsSaldo}
              setNewDataSaldo={setNewDataSaldo}
              kunjunganID={formDetailKunjungan.kunjungan_id}
              tagihanID={formDetailKunjungan.tagihan_id}
              rowsHistory={rowsHistory}
              totalSaldo={totalSaldo}
              handleClickCetak={handleClickCetak}
            />
          </div>
        </Paper>
      </Suspense>
    </>
  )
}

export default Saldo
